import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "../axios";
const { formatdate} = require('../dates')



type userType ={
   id: string,
   amount: number,
   username: string,
}

const UsersTable: React.FunctionComponent = () => {
   let [users, setUsers] = useState([]);
//    const dispatch = useDispatch();
//    const requests = useSelector((state: any) => state.btcDeposits.btcDeposits);
// let [currentdate, setCurrentdate] = useState(formatdate(new Date()));



   useEffect(() => {
      axios.get("/getinvestors").then((res) => {
         setUsers(res.data);
         console.log(res.data)
      });
      // let updatedate = () =>{
      //    setCurrentdate(formatdate(new Date()));
      //    console.log(currentdate, ":starr")
      //    }
      // let interval = setInterval(updatedate, 100000);
      //users?.map((user: userType) => {
      //    if(user.commisionAt == currentdate){
      //       console.log(user.amount + user.amount*0.15)
      //    }

      // return () => clearInterval(interval);

     
      //})
   }, []);
   // let redemedUsers = {...users}
   // console.log(redemedUsers[1].amount)
   // {
    
   // }

   const tableData = users?.map((user: userType) => {
      return (
         <tr>
            <td>{user.amount}</td>
            <td>{user.username}</td>
            <td>{user.id}</td>
         </tr>
      );
   });

   return (
      <Fragment>
         <section className="hero-section" style={{ height: "10vh" }}>
            <div className="container">
               <h1 className=" text-center text-white">Redemed list</h1>
            </div>
         </section>

         <section id="about" className="about-section pt-150 pb-20">
            <div className="container">
               <div className="over-next">
                  <table className="table ">
                     <thead>
                        <tr>
                           <th scope="col">Amount</th>
                           <th scope="col">Investor</th>
                           <th scope="col">id</th>
                        </tr>
                     </thead>
                     <tbody>{tableData}</tbody>
                  </table>
               </div>
            </div>
         </section>
      </Fragment>
   );
};

export default UsersTable;
